import { useState, useEffect } from 'react';
import { getPublishedSections, getPublishedArticlesBySection } from '../services/manual.service';
import type { ManualSection, ManualArticle } from '../lib/supabase.types';

export type SectionWithArticles = ManualSection & {
  articles: ManualArticle[];
};

export function useManualNavigation(language: string = 'ja') {
  const [sections, setSections] = useState<SectionWithArticles[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchNavigation = async () => {
      try {
        setLoading(true);
        const sectionsData = await getPublishedSections(language);

        const sectionsWithArticles = await Promise.all(
          sectionsData.map(async (section) => {
            const articles = await getPublishedArticlesBySection(section.id, language);
            return { ...section, articles };
          })
        );

        if (isMounted) {
          setSections(sectionsWithArticles);
          setError(null);
        }
      } catch (err) {
        console.error('Failed to load navigation:', err);
        if (isMounted) {
          setError(err instanceof Error ? err.message : 'Failed to load navigation');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchNavigation();

    return () => {
      isMounted = false;
    };
  }, [language]);

  return { sections, loading, error };
}
